// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"550":"ce90518d","950":"d249ca1f"}[chunkId] + ".chunk.js";
};